import { StyleProp, View, ViewStyle } from "react-native";
import Switch from "./Switch";
import { PropsWithChildren } from "react";
import Gap from "./Gap";
import HStack from "./HStack";
import CollapsibleView from "./CollapsibleView";
import { BodyLargeText } from "../components/FormattedText";

export type ActivableListItemProps = PropsWithChildren<{
    title: string;
    onSwitch: (newValue: boolean) => void;
    enabled: boolean;
    style?: StyleProp<ViewStyle>;
    collapsibleViewStyle?: StyleProp<ViewStyle>;
    disabled?: boolean;
}>;

const ActivableListItem = ({
    title,
    onSwitch,
    enabled,
    children,
    style,
    collapsibleViewStyle,
    disabled,
}: ActivableListItemProps) => {
    return (
        <View style={style}>
            <HStack>
                <Switch
                    style={{ paddingHorizontal: 0, paddingVertical: 0 }}
                    value={enabled}
                    onChange={onSwitch}
                    disabled={disabled}
                />
                <Gap gap="2/3" />
                <BodyLargeText>{title}</BodyLargeText>
            </HStack>
            <CollapsibleView isOpen={enabled} style={collapsibleViewStyle}>
                {children}
            </CollapsibleView>
        </View>
    );
};

export default ActivableListItem;
